import React, { ReactNode } from 'react'
import { Box, Grid, Stack } from '@mui/material'
import CustomText from '../CustomText/CustomText'
import { colors } from 'styles/colors'
import useGlobalStyles from 'styles/globalStyles';

interface Props {
  title: string;
  description?: string;
  buttons?: React.ReactNode[];
  height?: number;
  icon?: ReactNode;
}

export default function ProfileSectionHeader({
  title,
  description,
  buttons = [],
  height = 80,
  icon,
}: Props) {
  const globalstyles = useGlobalStyles();

  return (
    <Grid
      container
      flex={1}
      spacing={2}
      alignItems={'center'}
      justifyContent="space-between"
      height={height}
    >
      {/* Left: Text */}
      <Grid>
        <Stack
          direction={'row'}
          alignItems={'center'}
          spacing={1}
        >
          <Box className={globalstyles.profileSectionButton}>
            {icon}
          </Box>
          <CustomText
            text={title}
            color={colors.primary}
            fontSize={16}
            fontWeight={600}
          />

          {description && (
            <CustomText
              text={description}
              color={colors.secondary}
              fontSize={14}
            />
          )}
        </Stack>
      </Grid>

      {/* Right: Buttons */}
      <Grid
        display="flex"
        gap={1}
        flexWrap="wrap"
      >
        {buttons.map((item) => (item))}
      </Grid>
    </Grid>
  )
}
